/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { PlaylistTable_PlaylistFragmentDoc } from '../PlaylistTable/__generated__/PlaylistTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type PlaylistDuplicateMutationVariables = Types.Exact<{
  input: Types.PlaylistDuplicateInput;
}>;


export type PlaylistDuplicateMutation = { __typename: 'Mutation', playlistDuplicate: { __typename: 'PlaylistDuplicatePayload', playlist: { __typename: 'Playlist', id: string, title: string, description?: string | null, size: any, playlistType: Types.PlaylistType, createdAt: any, isPlaylistUsedByAnyConfiguration: boolean, isPlaylistUsedByAnySchedule: boolean, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }>, allDisplays: Array<{ __typename: 'Display', id: string }> } } };


export const PlaylistDuplicateDocument = gql`
    mutation PlaylistDuplicate($input: PlaylistDuplicateInput!) {
  playlistDuplicate(input: $input) {
    playlist {
      id
      ...PlaylistTable_playlist
    }
  }
}
    ${PlaylistTable_PlaylistFragmentDoc}`;
export type PlaylistDuplicateMutationFn = ApolloReactCommon.MutationFunction<PlaylistDuplicateMutation, PlaylistDuplicateMutationVariables>;

/**
 * __usePlaylistDuplicateMutation__
 *
 * To run a mutation, you first call `usePlaylistDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaylistDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playlistDuplicateMutation, { data, loading, error }] = usePlaylistDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaylistDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PlaylistDuplicateMutation, PlaylistDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PlaylistDuplicateMutation, PlaylistDuplicateMutationVariables>(PlaylistDuplicateDocument, options);
      }
export type PlaylistDuplicateMutationHookResult = ReturnType<typeof usePlaylistDuplicateMutation>;
export type PlaylistDuplicateMutationResult = ApolloReactCommon.MutationResult<PlaylistDuplicateMutation>;
export type PlaylistDuplicateMutationOptions = ApolloReactCommon.BaseMutationOptions<PlaylistDuplicateMutation, PlaylistDuplicateMutationVariables>;